import templateStr from 'text!./templates/service-request-documents.html';

const fn = ($window, httpSettings) => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            documents: '='
        },
        link: (scope) => {
            scope.tableConfig = {
                paginationSize: 1000
            };
            scope.documentsToDownload = [];
            scope.claimCenterDownloadURI = `${httpSettings.serviceBaseURLs.cc}document/servicerequest/servicerequestDocument`;
            scope.documentNotFoundURL = `${$window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))}/ServiceRequestDocumentError`;

            scope.addOrRemoveSelected = (isChecked, docItem) => {
                console.log(docItem);
                if (isChecked) {
                    scope.documentsToDownload.push(docItem);
                } else {
                    for (let i = 0; i < scope.documentsToDownload.length; i++) {
                        if (scope.documentsToDownload[i].publicID === docItem.publicID) {
                            scope.documentsToDownload.splice(i, 1);
                        }
                    }
                }
                if (scope.documents.length === scope.documentsToDownload.length) {
                    document.getElementById('selectAllDocs').checked = true;
                } else {
                    document.getElementById('selectAllDocs').checked = false;
                }
            };

            scope.selectAllCheckBoxes = (isSelectAll) => {
                for (let i = 0; i < scope.documents.length; i++) {
                    if (isSelectAll) {
                        document.getElementById(`docChkBox${scope.documents[i].publicID}`).checked = true;
                    } else {
                        document.getElementById(`docChkBox${scope.documents[i].publicID}`).checked = false;
                    }
                }
                if (isSelectAll) {
                    scope.documentsToDownload = scope.documents.slice();
                } else {
                    scope.documentsToDownload = [];
                }
            };

            scope.downloadAllDocuments = () => {
                for (let i = 0; i < scope.documentsToDownload.length; i++) {
                    const isFirstFile = i === 0;
                    scope.downloadFile(i, isFirstFile);
                    /* setTimeout(() => {
                        try {
                            const fileLink = document.getElementById(`doc${scope.documentsToDownload[i].publicID}`);
                            fileLink.click();
                        } catch (e) {
                            console.log(`failed to download document: ${scope.documentsToDownload[i].publicID}`);
                        }
                    }, 1000); */
                }
            };

            scope.downloadFile = (index, isFirstFile) => {
                const delaySeconds = isFirstFile ? 0 : 1500;
                setTimeout(() => {
                    try {
                        const fileLink = document.getElementById(`doc${scope.documentsToDownload[index].publicID}`);
                        fileLink.click();
                    } catch (e) {
                        console.log(`failed to download document: ${scope.documentsToDownload[index].publicID}`);
                    }
                }, delaySeconds);
            };
        }
    };
};
fn.$inject = ['$window', 'httpSettings'];
export default fn;
